export const SET_AIRPORT = 'SET_AIRPORT';
export const SELECTED_AIRPORT = 'SELECTED_AIRPORT';
export const CLEAR_AIRPORT = 'CLEAR_AIRPORT';

export function setAirport(airports) {
    return {
        type: SET_AIRPORT,
        airports
    };
}

export function otherAirport() {
    return {
        type: SELECTED_AIRPORT,
    };
}
export function clearAirport() {
    return {
        type: CLEAR_AIRPORT,
    };
}







// WEBPACK FOOTER //
// ./src/redux/actions/airport.js